/**
 * Created by Jerker Nord on 2020-02-03.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {BonusBunniesSpineBSymbol} from "../../symbols/BonusBunniesSpineBSymbol";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";
import {TimelineLite} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesSoundConfig} from "../../BonusBunniesSoundConfig";
import {BonusBunniesStickyBonusValueContainer} from "../../winpresentation/stickybonusvalues/BonusBunniesStickyBonusValueContainer";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";

export class BonusBunniesValueSymbolReplacerView extends BaseView {

    private _layer:ScalableLayer;
    private _spineVSymbols:BonusBunniesSpineBSymbol[];
    private _spineB2Symbols:BonusBunniesSpineBSymbol[];
    private _spineB3Symbols:BonusBunniesSpineBSymbol[];
    private _spineB4Symbols:PIXI.Sprite[];
    private _fertilizerKissSoundPlayed:boolean = false;
    private _upgradeSound:string[] = [BonusBunniesSoundConfig.instance.BONUS_MULTIPLIER_UPGRADE_REEL_1,
        BonusBunniesSoundConfig.instance.BONUS_MULTIPLIER_UPGRADE_REEL_2];
    private _currentUpgradeSound:number = 0;
    private _isSpinning:boolean = false;

    constructor(resourcesGroup:ResourcesGroupName) {
        super(resourcesGroup);
        this._layer = StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.BASE_FEATURE.name);
        this._layer.addChild(this);
        EventHandler.addEventListener(this, SpinEvent.START, () => this.onSpinStart());
        EventHandler.addEventListener(this, SpinEvent.STOPPED, () => this.onSpinStopped());
    }

    private onSpinStart():void{
        this._isSpinning = true;
    }

    private onSpinStopped():void{
        this._isSpinning = false;
        SlotGame.sound.stopEffect(BonusBunniesSoundConfig.instance.REELS_SPINNING_START_ON_SPIN_START);
    }

    protected initAnimations():void {
        this._spineVSymbols = [];
        for(let i:number = 0; i < 5; i++) {
            for(let j:number = 0; j < 5; j++) {
                const spineVSymbol:BonusBunniesSpineBSymbol = new BonusBunniesSpineBSymbol(GameResources.getSpineAsset("SpineV"));
                spineVSymbol.state.setAnimation(0, "land", true);
                spineVSymbol.position = new PIXI.Point(Helper.getSymbolPositions(i, j)[0], Helper.getSymbolPositions(i, j)[1]);
                spineVSymbol.symPosition = new PIXI.Point(i, j);
                spineVSymbol.visible = false;
                this.addChild(spineVSymbol);
                this._spineVSymbols.push(spineVSymbol);
            }
        }
        this._spineB2Symbols = [];
        this._spineB3Symbols = [];
        this._spineB4Symbols = [];
    }

    public restore():void {
        for(let i:number = 0; i < this._spineVSymbols.length; i++) {
            this._spineVSymbols[i].visible = false;
            this._spineVSymbols[i].skeleton.setSkin(null);
            this._spineVSymbols[i].skeleton.setSkinByName("default");
            this._spineVSymbols[i].skeleton.setSlotsToSetupPose();
            this.showReelSymbol(i);
        }
        while(this._spineB2Symbols.length > 0) {
            this.removeChild(this._spineB2Symbols.pop()!);
        }
        while(this._spineB3Symbols.length > 0) {
            this.removeChild(this._spineB3Symbols.pop()!);
        }
        while(this._spineB4Symbols.length > 0) {
            this.removeChild(this._spineB4Symbols.pop()!);
        }
    }

    //Only used on Bonus game start
    public getAttentionOnAllVSymbolsTL():TimelineLite {
        const attentionTL:TimelineLite = new TimelineLite();
        const values:BonusBunniesStickyBonusValueContainer[] = BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPView.getAllActiveBonusValues();
        let valueCounter:number = 0;
        for(let i:number = 0; i < this._spineVSymbols.length; i++) {
            if(this._spineVSymbols[i].visible == true) {
                let spineSym:BonusBunniesSpineBSymbol = this._spineVSymbols[i];
                let value:BonusBunniesStickyBonusValueContainer = values[valueCounter];
                valueCounter++;
                attentionTL.add([
                    () => spineSym.state.setAnimation(0, "land", false),
                    () => value.getValueText().alpha = 1
                ], "+=0.4");
                attentionTL.add(() => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_CARROT_LANDING));
            }
        }
        return attentionTL;
    }

    public playVSymbolAttention(reelId:number, playSound:boolean = true):void {
        const symbolAttentionTL:TimelineLite = new TimelineLite();
        symbolAttentionTL.add(() => this._spineVSymbols[reelId].updateTransform());
        symbolAttentionTL.add(() => this._spineVSymbols[reelId].visible = true);
        symbolAttentionTL.add(() => this.hideReelSymbol(reelId));
        symbolAttentionTL.add([
            () => {
                if(playSound == true) {
                    SlotGame.sound.stopEffect(BonusBunniesSoundConfig.instance.REELS_SPINNING_LAST_SPIN_BONUS);
                    BonusBunniesSoundConfig.instance.REELS_SPINNING_START_ON_SPIN_START = BonusBunniesSoundConfig.instance.REELS_SPINNING_DEFAULT;
                    if (this._isSpinning == true){
                        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.REELS_SPINNING_START_ON_SPIN_START);
                    }
                    SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_CARROT_LANDING);
                }
            },
            () => this._spineVSymbols[reelId].state.setAnimation(0, "land", false)
        ]);
        symbolAttentionTL.add(BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPController.setStickyBonus(this._spineVSymbols[reelId].symPosition.x, this._spineVSymbols[reelId].symPosition.y));
    }

    public playVSymbolAnimation(reel:number, row:number, playSound:boolean = true):void {
        for(let i:number = 0; i < this._spineVSymbols.length; i++) {
            if(this._spineVSymbols[i].symPosition.x == reel && this._spineVSymbols[i].symPosition.y == row) {
                if(playSound == true) {
                    this.playUpgradeSound();
                }
                this._spineVSymbols[i].state.setAnimation(0, "trigger", false);
                break;
            }
        }
    }

    private playUpgradeSound():void {
        SlotGame.sound.playEffect(this._upgradeSound[this._currentUpgradeSound]);
        this._currentUpgradeSound++;
        if(this._currentUpgradeSound == this._upgradeSound.length) {
            this._currentUpgradeSound = 0;
        }
    }

    public activateB2Symbol(reelId:number):void {
        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_HARVESTER_LANDING);
        SlotGame.sound.stopEffect(BonusBunniesSoundConfig.instance.REELS_SPINNING_LAST_SPIN_BONUS);
        BonusBunniesSoundConfig.instance.REELS_SPINNING_START_ON_SPIN_START = BonusBunniesSoundConfig.instance.REELS_SPINNING_DEFAULT;
        if (this._isSpinning == true){
            SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.REELS_SPINNING_START_ON_SPIN_START);
        }
        const spineB2Symbol:BonusBunniesSpineBSymbol = new BonusBunniesSpineBSymbol(GameResources.getSpineAsset("SpineB2"));
        spineB2Symbol.position = this._spineVSymbols[reelId].position;
        spineB2Symbol.symPosition = this._spineVSymbols[reelId].symPosition;
        this._spineB2Symbols.push(spineB2Symbol);
        this.addChild(spineB2Symbol);
        BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPController.setStickyBonus(this._spineVSymbols[reelId].symPosition.x, this._spineVSymbols[reelId].symPosition.y);
        this.hideReelSymbol(reelId);
    }

    public playB2SymbolAnimation(reel:number, row:number):void {
        for(let i:number = 0; i < this._spineB2Symbols.length; i++) {
            if(this._spineB2Symbols[i].symPosition.x == reel && this._spineB2Symbols[i].symPosition.y == row) {
                this._spineB2Symbols[i].state.setAnimation(0, "trigger", false);
                break;
            }
        }
    }

    public activateB3Symbol(reelId:number):void {
        this._fertilizerKissSoundPlayed = false;
        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_FERTILIZER_LANDING);
        SlotGame.sound.stopEffect(BonusBunniesSoundConfig.instance.REELS_SPINNING_LAST_SPIN_BONUS);
        BonusBunniesSoundConfig.instance.REELS_SPINNING_START_ON_SPIN_START = BonusBunniesSoundConfig.instance.REELS_SPINNING_DEFAULT;
        if (this._isSpinning == true){
            SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.REELS_SPINNING_START_ON_SPIN_START);
        }
        const spineB3Symbol:BonusBunniesSpineBSymbol = new BonusBunniesSpineBSymbol(GameResources.getSpineAsset("SpineB3"));
        spineB3Symbol.position = this._spineVSymbols[reelId].position;
        spineB3Symbol.symPosition = this._spineVSymbols[reelId].symPosition;
        this._spineB3Symbols.push(spineB3Symbol);
        this.addChild(spineB3Symbol);
        BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPController.setStickyBonus(this._spineVSymbols[reelId].symPosition.x, this._spineVSymbols[reelId].symPosition.y);
        this.hideReelSymbol(reelId);
    }

    public playB3SymbolAnimation(reel:number, row:number):void {
        for(let i:number = 0; i < this._spineB3Symbols.length; i++) {
            if(this._spineB3Symbols[i].symPosition.x == reel && this._spineB3Symbols[i].symPosition.y == row) {
                if(this._fertilizerKissSoundPlayed == false) {
                    this._fertilizerKissSoundPlayed = true;
                    SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_FERTILIZER_KISS);
                }
                this._spineB3Symbols[i].state.setAnimation(0, "trigger", false);
                break;
            }
        }
    }

    public activateB4Symbol(reelId:number):void {
        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_SETTLER_LANDING);
        SlotGame.sound.stopEffect(BonusBunniesSoundConfig.instance.REELS_SPINNING_LAST_SPIN_BONUS);
        BonusBunniesSoundConfig.instance.REELS_SPINNING_START_ON_SPIN_START = BonusBunniesSoundConfig.instance.REELS_SPINNING_DEFAULT;
        if (this._isSpinning == true){
            SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.REELS_SPINNING_START_ON_SPIN_START);
        }
        const spineB4Symbol:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("B4/B4")[0]);
        spineB4Symbol.anchor.set(0.5, 0.5);
        spineB4Symbol.position = this._spineVSymbols[reelId].position;
        this._spineB4Symbols.push(spineB4Symbol);
        this.addChild(spineB4Symbol);
        BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPController.setStickyBonus(this._spineVSymbols[reelId].symPosition.x, this._spineVSymbols[reelId].symPosition.y);
        this.hideReelSymbol(reelId);
    }

    private hideReelSymbol(reelId:number):void {
        let reel:(StateReelSymbol | null)[] = Reels.allSymbols(reelId);
        if(reel[1]) {
            reel[1].visible = false;
        }
    }

    private showReelSymbol(reelId:number):void {
        let reel:(StateReelSymbol | null)[] = Reels.allSymbols(reelId);
        if(reel[1]) {
            reel[1]!.visible = true;
        }
    }
}